import { atom } from "recoil";
import { selector, selectorFamily } from "./recoilSelectors";
import { Uid } from "../types/core";
import { Zone } from "../types/zone";
import { atomWithIndexedPersistence } from "../utils/persistence";
import { zonesLayerState } from "./geojsonState";

export const allZonesState = selector({
    key: "zones.all",
    get: ({ get }) => {
        const zonesLayer = get(zonesLayerState);
        if (!zonesLayer) {
            return [] as Zone[];
        }
        const obj = zonesLayer as unknown as GeoJSON.FeatureCollection<GeoJSON.Geometry>;
        if (!obj.features) {
            return [] as Zone[];
        }
        const sortedZones = obj.features
            .map((feat) => {
                const points = feat.geometry as any;
                return {
                    ...feat.properties,
                    points: points.coordinates[0],
                } as Zone;
            })
            .sort((z1, z2) => {
                return z1.name.localeCompare(z2.name);
            });
        return sortedZones;
    },
});

export const zonesState = selector({
    key: "zones",
    get: ({ get }) => {
        return get(allZonesState);
    },
});

export const zoneState = selectorFamily<Zone | undefined, string>({
    key: 'zone',
    get: (uid) => ({ get }) => {
        const zones = get(zonesState);
        return zones.find(z => z.uid === uid);
    }
});

export const zonesSelectedUidsState = atomWithIndexedPersistence("zones.selected.uids", [] as Uid[]);

export const zonesSelectedState = selector({
    key: "zones.selected",
    get: ({ get }) => get(zonesSelectedUidsState)
        .map(uid => get(zoneState(uid)))
        .filter(zone => !!zone) as Zone[],
});

export const editZoneState = atom<Zone>({ key: "zone.edit", default: undefined });

